import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

// import Media from 'react-media';
// import styles from 'theme';

import H3 from '../H3/H3';
import P from '../P/P';
import Icon from '../Icon/Icon';

const DrawerHeaderWrapper = styled.div`
  background: ${props => props.theme.colors.white};
  padding: 0 15px;

  h3 {
    margin-bottom: 5px;
  }
`;

const LogoWrapper = styled.div`
  position: relative;
  text-align: left;
  display: block;

  svg {
    width: 100px;
    margin: 20px;
  }

  @media only screen and (max-width: ${props => props.theme.mq.large}) {
    display: none;
  }
`;

const UserInfoWrapper = styled.div`
  padding: 0 15px 10px;
  display: block;

  @media only screen and (max-width: ${props => props.theme.mq.large}) {
    padding: 20px 15px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
  

  /* ${props =>
    props.small &&
    css`
      border: 1px solid red;
    `}

  ${props =>
    props.large &&
    css`
      border: 1px solid black;
    `} */
`;

const Email = styled(P)`
  font-size: ${props => props.theme.fonts.sizeSmall};
  margin-top: 30px;
`;

class DrawerHeader extends React.Component {
  render() {
    const { firstname, lastname, email } = this.props;
    return (
      <DrawerHeaderWrapper>
        <LogoWrapper>
          <Icon id="ugent" />
        </LogoWrapper>
        {(firstname || lastname || email) && (
          // <Media query={{ maxWidth: styles.mq.large }}>
          //   {matches => (
          <UserInfoWrapper large>
            {firstname && <H3>{firstname}</H3>}
            {lastname && <P>{lastname}</P>}
            {email && <Email>{email}</Email>}
          </UserInfoWrapper>
        )
        //   )}
        // </Media>
        }
      </DrawerHeaderWrapper>
    );
  }
}

DrawerHeader.propTypes = {
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  email: PropTypes.string
};

export default DrawerHeader;



// WEBPACK FOOTER //
// ./src/components/Drawer/DrawerHeader.js